import { Box, Button, styled, Typography } from '@mui/material'
import type { FC, ReactNode } from 'react'
import type { To } from 'react-router-dom'

import { COLORS, unit, UnstyledLink } from '@hcr/pwa/components'

interface ErrorProps {
  dataAnalyticsId: string
  description: string
  image: ReactNode
  link?: {
    label: string
    target: To
  }
  title: string
}

export const Error: FC<ErrorProps> = ({ dataAnalyticsId, description, link, title, image }) => {
  return (
    <Container data-analyticsid={dataAnalyticsId}>
      {image}
      <Description>
        <Typography variant='titleM'>{title}</Typography>
        <Typography variant='bodyM'>{description}</Typography>
      </Description>
      {link && (
        <Button component={UnstyledLink} to={link.target} variant='contained' color='primary'>
          {link.label}
        </Button>
      )}
    </Container>
  )
}

const Section = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Container = styled(Section)`
  background-color: ${COLORS.vaalea['60%']};
  height: 100%;
  text-align: center;
  gap: ${unit(7)};
  padding: ${unit(7)};
`

const Description = styled(Section)`
  gap: ${unit(2.5)};
`
